export default "__VITE_ASSET__C5uEFCR0__"